import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { DefaultChargesPage } from "./default-charges-page";
import { SettingsInfo } from "./settings-info";
import { HeaderSettings } from "./header-settings";    // ← new
import { ProfilePage } from "./profile";
import { styled } from '@mui/system';
import { useAuth } from "../hooks/useAuth";

const StyledTab = styled(Tab)(({ theme }) => ({
  fontSize: '16px',
  color: 'black',
  fontWeight: "600"
}));

export const SettingsPage = () => {
  const { role } = useAuth();
  const isAllowed = role === 'admin' || role === 'manager';

  // If admin: tabs = [Header, Settings, Default Charges, Profile]
  // If not: tabs = [Profile]
  const [selectedTab, setSelectedTab] = useState( isAllowed ? 0 : 0 );

  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return role ? (
    <Box>
      <Tabs value={selectedTab} onChange={handleTabChange}>
        {isAllowed && <StyledTab label="Header" />}
        {isAllowed && <StyledTab label="Settings" />}
        {isAllowed && <StyledTab label="Default Charges" />}
        <StyledTab label="Profile" />
      </Tabs>

      {/*
         indexes when isAllowed:
           0 → HeaderSettings
           1 → SettingsInfo
           2 → DefaultChargesPage
           3 → ProfilePage

         when _not_ isAllowed:
           0 → ProfilePage
      */}
      {isAllowed && selectedTab === 0 && <HeaderSettings />}
      {isAllowed && selectedTab === 1 && <SettingsInfo />}
      {isAllowed && selectedTab === 2 && <DefaultChargesPage />}
      {(
         (!isAllowed && selectedTab === 0) ||
         (isAllowed && selectedTab === 3)
       ) &&
        <ProfilePage />
      }
    </Box>
  ) : null;
};
